/** A random number generator returning values in [0, 1). Injected so logic can be tested deterministically. */
export type Rng = () => number;

export const defaultRng: Rng = Math.random;

/** Small, fast seeded generator for tests and reproducible sessions. */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Fisher–Yates shuffle, in place. Returns the same array. */
export function shuffle<T>(a: T[], rng: Rng = defaultRng): T[] {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const rand = (a: number, b: number, rng: Rng = defaultRng): number => a + rng() * (b - a);
